import { useState } from 'react';
import { colors } from '../theme';

/**
 * KAAMWALA logo.
 *
 * Replace kamwalaweb/public/logo.png with the brand PNG and it is picked up
 * everywhere automatically (same filename, no code change). If the image ever
 * fails to load, the blue/orange "K" mark below is drawn instead so no page
 * shows a broken image.
 */
const Logo = ({ size = 56, radius }) => {
  const [failed, setFailed] = useState(false);
  const borderRadius = radius !== undefined ? radius : size * 0.28;

  if (!failed) {
    return (
      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt="KAAMWALA"
        onError={() => setFailed(true)}
        style={{ width: size, height: size, borderRadius, objectFit: 'contain', flex: '0 0 auto' }}
      />
    );
  }

  return (
    <div
      style={{
        width: size, height: size, borderRadius, flex: '0 0 auto',
        background: colors.primary, color: '#fff',
        display: 'grid', placeItems: 'center', position: 'relative',
        fontSize: size * 0.52, fontWeight: 900,
      }}
    >
      K
      <span
        style={{
          position: 'absolute', right: size * 0.1, bottom: size * 0.1,
          width: size * 0.24, height: size * 0.24,
          borderRadius: size * 0.12, background: colors.accent,
        }}
      />
    </div>
  );
};

export default Logo;
